<script>
export default {
  name: 'app',
  render (h) {
    if (this.$mobile) {
      return h('MLayout')
    } else {
      return h('PCLayout')
    }
  }
}
</script>
